module.exports = __webpack_public_path__ + "static/media/m5.dfbd69e0.jpg";